import { useState } from "react";
import { useLocation } from "react-router";
import { useSelector } from "react-redux";
import { CountryDropdown } from "react-country-region-selector";
import DebouncedInput from "./DebouncedInput";
import { APPLICATION_LIST, BASIC_LOGIN_APP_LIST, SITE_ADMIN_APP_LIST } from "../../../utils/";

interface Props {
    columnName: string;
    handleChange: (value: string, columnName: string) => void;
}

const CmpFilter = ({ columnName, handleChange }: Props) => {
    const [value, setValue] = useState("");
    const location = useLocation().pathname;

    const onChange = (val: any) => {
        setValue(val);
        handleChange(val, columnName);
    };

    const { currentUser } = useSelector((state: any) => state.users);
    const specialtyOptions = useSelector((state: any) => state.specialtyOptions);
    const whiteListedCountry = currentUser?.country || [];

    return (
        <>
            {columnName === "country" ? (
                currentUser.userType === 1 ? (
                    <CountryDropdown
                        classes="form-control mb-0"
                        valueType="short"
                        value={value}
                        onChange={(val: any) => {
                            onChange(val);
                        }}
                        whitelist={whiteListedCountry}
                        defaultOptionLabel="Select All"
                    />
                ) : (
                    <CountryDropdown
                        classes="form-control mb-0"
                        valueType="short"
                        value={value}
                        onChange={(val: any) => {
                            onChange(val);
                        }}
                        defaultOptionLabel="Select All"
                    />
                )
            ) : columnName === "appName" ? (
                <select
                    className={`form-control mb-0`}
                    onChange={(e) => {
                        e.persist();
                        onChange(e.target.value);
                    }}
                >
                    <option value="">Select All</option>
                    {location === "/global-config/basic-login"
                        ? BASIC_LOGIN_APP_LIST.map((option, index) => {
                              return (
                                  <option key={index} value={option.id}>
                                      {option.name}
                                  </option>
                              );
                          })
                        : APPLICATION_LIST.map((option, index) => {
                              return (
                                  <option key={index} value={option.id}>
                                      {option.name}
                                  </option>
                              );
                          })}
                </select>
            ) : columnName === "adminPermissions" ? (
                <select
                    className={`form-control mb-0`}
                    onChange={(e) => {
                        e.persist();
                        onChange(e.target.value);
                    }}
                >
                    <option value="">Select All</option>
                    {SITE_ADMIN_APP_LIST.map((option, index) => {
                        return (
                            <option key={index} value={option.id}>
                                {option.name}
                            </option>
                        );
                    })}
                </select>
            ) : columnName === "status" ? (
                <select
                    className={`form-control mb-0`}
                    onChange={(e) => {
                        e.persist();
                        onChange(e.target.value);
                    }}
                >
                    <option value="">Select All</option>
                    <option value="0">Inactive</option>
                    <option value="1">Active</option>
                </select>
            ) : columnName === "isEnabled" ? (
                <select
                    className={`form-control mb-0`}
                    onChange={(e) => {
                        e.persist();
                        onChange(e.target.value);
                    }}
                >
                    <option value="">Select All</option>
                    <option value="0">Disabled</option>
                    <option value="1">Enabled</option>
                </select>
            ) : columnName === "publishStatus" ? (
                <select
                    className={`form-control mb-0`}
                    onChange={(e) => {
                        e.persist();
                        onChange(e.target.value);
                    }}
                >
                    <option value="">Select All</option>
                    <option value="true">Published</option>
                    <option value="false">UnPublished</option>
                </select>
            ) : columnName === "abbvieProGroupSpecialtyByGroupId" ? (
                <select
                    className={`form-control mb-0`}
                    onChange={(e) => {
                        e.persist();
                        onChange(e.target.value);
                    }}
                >
                    <option value="">Select All</option>
                    {specialtyOptions &&
                        specialtyOptions.length > 0 &&
                        specialtyOptions.map((option: Record<string, string>, index: number) => {
                            return (
                                <option key={index} value={option.id}>
                                    {option.name}
                                </option>
                            );
                        })}
                </select>
            ) : (
                <DebouncedInput
                    type="text"
                    value={value}
                    onChange={(val) => {
                        onChange(val);
                    }}
                    placeholder="Search..."
                />
            )}
        </>
    );
};

export default CmpFilter;
